// extracted by mini-css-extract-plugin
export default {"wrap":"Projects_wrap__OmTTt","content":"Projects_content__RkPq8","subtitle":"Projects_subtitle__YdzE3","image":"Projects_image__TpmlQ"};